<template>
  <ScrollTop v-if="showScrollTop" />
  <div class="params-row request-and-check-all">
    <SwitchSlide :is-active="!store.bypassQueryNews" @toggle="toggleUseRequest"
      >Utiliser la requête</SwitchSlide
    >
    <CheckBox
      :checked="isAllSelected"
      @update:checked="
        () => (isAllSelected ? unselectAllFilters() : selectAllFilters())
      "
    >
      Toutes les actualités
    </CheckBox>
  </div>
  <div class="params-row">
    <div class="page-settings filters">
      <FilterCheckBox
        label="Publications"
        color="var(--clr-network)"
        :item-count="store.publicationsCount"
        :is-checked="store.prmNewsFilters.includes(NEWS_FILTERS.PUBLICATIONS)"
        @check="addFilter(NEWS_FILTERS.PUBLICATIONS)"
        @uncheck="removeFilter(NEWS_FILTERS.PUBLICATIONS)"
      />
      <FilterCheckBox
        label="Articles"
        color="var(--color-articles)"
        :item-count="store.linkCount"
        :is-checked="store.prmNewsFilters.includes(NEWS_FILTERS.ARTICLES)"
        @check="addFilter(NEWS_FILTERS.ARTICLES)"
        @uncheck="removeFilter(NEWS_FILTERS.ARTICLES)"
      />
    </div>
    <div class="page-settings">
      <DropdownMenu
        v-model="selectedSorterOption"
        :options="sortersOptions"
        label="Trier par :"
      />

      <DropdownMenu
        v-model="selectedLimitOption"
        :options="limitOptions"
        label="Actualités par page :"
      />
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { storeToRefs } from "pinia";
import { useRoute } from "vue-router";

import SwitchSlide from "@follaw-fr/components/reusable/atoms/SwitchSlide.vue";
import CheckBox from "@follaw-fr/components/reusable/atoms/CheckBox.vue";
import FilterCheckBox from "@follaw-fr/components/reusable/atoms/FilterCheckBox.vue";
import { usePrmStore } from "@follaw-fr/stores/prm";
import { NEWS_FILTERS } from "@follaw-fr/stores/prm";
import ScrollTop from "@follaw-fr/components/reusable/atoms/ScrollTop.vue";
import DropdownMenu from "@follaw-fr/components/reusable/atoms/DropdownMenu.vue";
import { useDropdown } from "@follaw-fr/composables/useDropdown";

const props = defineProps({
  isZoomed: {
    type: Boolean,
    default: false,
  },
});

const route = useRoute();
const store = usePrmStore();
const { selectedPrmNewsParams } = storeToRefs(store);
const fetchNews = async () => {
  selectedPrmNewsParams.value.from = 0;
  if (props.isZoomed) {
    await store.fetchOnePersonnalityNews(route.params._id);
  } else {
    await store.fetchFollawedPrmNews();
  }
};

const { options: sortersOptions, selectedValue: selectedSorterOption } =
  useDropdown({
    options: {
      created_at: "Date",
      number_of_retweets: "Partages",
    },
    selectedFilters: selectedPrmNewsParams,
    filterKey: "sort_field",
    onChange: () => fetchNews(),
  });

const { options: limitOptions, selectedValue: selectedLimitOption } =
  useDropdown({
    options: { 10: "10", 20: "20", 50: "50", 200: "200" },
    selectedFilters: selectedPrmNewsParams,
    filterKey: "size",
    onChange: () => {
      selectedPrmNewsParams.value.from = 0;
      fetchNews();
    },
  });

const showScrollTop = computed(() => selectedPrmNewsParams.value.size > 20);

const addFilter = (filter) => {
  store.prmNewsFilters.push(filter);
  fetchNews();
};

const removeFilter = (filter) => {
  store.prmNewsFilters = store.prmNewsFilters.filter((f) => f !== filter);
  fetchNews();
};

const selectAllFilters = () => {
  store.prmNewsFilters = [NEWS_FILTERS.PUBLICATIONS, NEWS_FILTERS.ARTICLES];
  fetchNews();
};

const unselectAllFilters = () => {
  store.prmNewsFilters = [];
  fetchNews();
};

const isAllSelected = computed(
  () => store.prmNewsFilters.length === Object.keys(NEWS_FILTERS)?.length
);

const toggleUseRequest = () => {
  store.bypassQueryNews = !store.bypassQueryNews;
  fetchNews();
};

fetchNews();
</script>

<style lang="scss" scoped>
.request-and-check-all {
  justify-content: flex-start;
  gap: 15px;
}
.filters {
  gap: 10px;
}
</style>
